// Packages and components
import React from 'react';
import { CloseButton } from './SHDCloseButton.style';

// Helpers and utlities
import { edgeSize } from '@theme/globals/sizing';

// Types
import type { SHDCloseButtonProps } from './SHDCloseButton.d';

const SHDCloseButton: React.FC<SHDCloseButtonProps> = ({
  className = 'button-close',
  size = 'small',
  onClick,
  isFilled = false,
  background = 'black-alpha-50',
}) => {
  return (
    <CloseButton
      role="button"
      className={className}
      onClick={onClick}
      buttonSize={size}
      buttonBackgroundColor={background}
      buttonIsFilled={isFilled}
    >
      <svg
        role="img"
        width={edgeSize[size]}
        height={edgeSize[size]}
        viewBox="0 0 9 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="-0.00488281"
          y="2.17188"
          width="2"
          height="10"
          rx="1"
          transform="rotate(-45 -0.00488281 2.17188)"
          fill={isFilled ? 'white' : background}
        />
        <rect
          x="7.06836"
          y="0.757812"
          width="2"
          height="10"
          rx="1"
          transform="rotate(45 7.06836 0.757812)"
          fill={isFilled ? 'white' : background}
        />
      </svg>
    </CloseButton>
  );
};

export default SHDCloseButton;
